export default __webpack_public_path__ + "static/media/qcjdy.8526a553.png";